import {connect} from 'react-redux';
import {setMetadataCategoriesAction} from '@pluto/metadata-categories/Redux/CategoriesActions';
import {setQcGenres} from '@pluto/genres/Redux/GenresActions';
import {CategoriesState} from '@pluto/metadata-categories/CategoriesTypes';
import {setQcDescriptors} from '@pluto/rating-descriptors/Redux/ratingDescriptorsAction';
import {setItemAction} from 'VideoAudioQC/QCMedia/Redux/QCMediaActions';
import ContentItemViewMetadataContainer from './ContentItemViewMetadataContainer';
import {
    updateLocalizedMetadataAction,
    setContentItemViewMetadataGeneral,
    updateTerritorialMetadataAction,
} from './Redux/ContentItemViewMetadataActions';
import {
    ContentItemViewMetadataState,
    Descriptor,
    VideoTypeData,
} from './ContentItemViewMetadataTypes';
import {Genre} from '../../types';

export type State = {
    contentItemView: {
        contentItemViewMetadata: ContentItemViewMetadataState;
    };
    genres: {
        isLoading: boolean;
        genres: Genre[];
    };
    ratingDescriptors: {
        isLoading: boolean;
        descriptors: Descriptor[];
    };
    qcMetadataCategories: CategoriesState;
    videoAudioQC: {
        qcMedia: {
            item: {
                video: VideoTypeData;
            };
        };
    };
};

export const mapState = (state: State) => {
    const {
        contentItemView,
        genres,
        qcMetadataCategories,
        ratingDescriptors,
        videoAudioQC: {
            qcMedia: {item},
        },
    } = state;
    const {contentItemViewMetadata} = contentItemView;
    const {data: categories, isLoading: isLoadingCategories} = qcMetadataCategories;
    return {
        ...contentItemViewMetadata,
        genres: genres.genres,
        categories,
        isLoadingCategories,
        isLoadingGenres: genres.isLoading,
        ratingDescriptors: ratingDescriptors.descriptors,
        isLoadingDescriptors: ratingDescriptors.isLoading,
        videoData: item,
    };
};

export const mapDispatch = {
    setContentItemViewMetadataGeneral,
    updateLocalizedMetadata: updateLocalizedMetadataAction,
    setMetadataCategories: setMetadataCategoriesAction,
    updateTerritorialMetadata: updateTerritorialMetadataAction,
    setQcGenres,
    setQcDescriptors,
    setVideoData: setItemAction as any,
};

export default connect(mapState, mapDispatch)(ContentItemViewMetadataContainer);
